<template>
  <div class='c-outer-div h-100'>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-card>
            <v-card-title class="d-block">
              <v-row>
                <v-col cols="12" sm="auto">Client Invoice</v-col>
                <v-spacer></v-spacer>
                <v-col cols="12" md="3" lg="3">
                  <v-select
                    dense
                    hide-details
                    label="Group by"
                    item-text="title"
                    item-value="val"
                    multiple
                    clearable
                    :items="groupByItems"
                    v-model="groupBy"
                  ></v-select>
                </v-col>
                <v-col cols="12" md="3" lg="3">
                  <v-text-field
                    dense
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search"
                    single-line
                    hide-details
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <!-- Date picker -->
                <v-col>
                  <RangeDatePickerMenu
                    v-model="filter.DateRange"
                    label="Invoice Date Period"
                    showButtons
                  />
                </v-col>
                <!-- /Date picker -->
                <!-- Projects list -->
                  <v-col>
                    <v-select
                      dense
                      hide-details
                      item-value="Project_ID"
                      :items="projects"
                      item-text="Description"
                      label="Project"
                      v-model="filter.Project_ID"
                      multiple
                      clearable
                      @click:clear="selectAllProjects = false"
                    >
                      <template v-slot:prepend-item>
                        <div class="px-4 py-2">
                          <v-text-field
                            dense
                            hide-details
                            label="Search project"
                            v-model="searchProject"
                          ></v-text-field>
                        </div>
                        <div class="px-4">
                          <v-checkbox
                            dense
                            v-model="selectAllProjects"
                            @change="selectAll"
                            label="Select all"
                          ></v-checkbox>
                        </div>
                        <v-divider></v-divider>
                      </template>
                      <template v-slot:selection="{ item, index }">
                        <v-chip v-if="index === 0">
                          <span>{{ item.Description }}</span>
                        </v-chip>
                        <span
                          v-if="index === 1"
                          class="grey--text caption"
                        >
                          (+{{ filter.Project_ID.length - 1 }} others)
                        </span>
                      </template>
                    </v-select>
                  </v-col>
                <!-- /Projects list -->
                <!--Clients list-->
                <v-col>
                  <v-select
                    dense
                    hide-details
                    :items="clients"
                    item-value="Client_ID"
                    item-text="Name"
                    label="Client"
                    multiple
                    v-model="filter.Client_ID"
                    clearable
                    @click:clear="selectAllClients = false"
                  >
                    <template v-slot:prepend-item>
                      <div class="px-4 py-2">
                        <v-text-field
                          dense
                          hide-details
                          label="Search client"
                          v-model="searchClient"
                        ></v-text-field>
                      </div>
                      <div class="px-4">
                        <v-checkbox
                          dense
                          v-model="selectAllClients"
                          @change="selectAll"
                          label="Select all"
                        ></v-checkbox>
                      </div>
                      <v-divider></v-divider>
                    </template>
                    <template v-slot:selection="{ item, index }">
                      <v-chip v-if="index === 0">
                        <span>{{ item.Name }}</span>
                      </v-chip>
                      <span
                        v-if="index === 1"
                        class="grey--text caption"
                      >
                        (+{{ filter.Client_ID.length - 1 }} others)
                      </span>
                    </template>
                  </v-select>
                </v-col>
                <v-col cols="12" md="3" lg="3">
                  <v-autocomplete
                    label="Department"
                    :items="departments"
                    v-model="filter.Dep_ID"
                    item-text="Dep_Name"
                    item-value="Dep_ID"
                    multiple
                    dense
                    hide-details
                    :disable-lookup="true"
                    clearable
                    @click:clear="clearDepartmentList()"
                    :search-input.sync="searchDepartment"
                  >
                    <template v-slot:prepend-item>
                      <div class="px-4">
                        <v-checkbox
                          dense
                          v-model="selectAllDepartments"
                          @change="selectAll"
                          label="Select all"
                        ></v-checkbox>
                      </div>
                      <v-divider></v-divider>
                    </template>
                    <template v-slot:selection="{ item, index }">
                      <v-chip v-if="index === 0">
                        <span>{{ item.Dep_Name }}</span>
                      </v-chip>
                      <span
                        v-if="index === 1"
                        class="grey--text caption"
                      >
                        (+{{ filter.Dep_ID.length - 1 }} others)
                      </span>
                    </template>
                  </v-autocomplete>
                </v-col>
                <!-- /Clients list -->
                <v-col cols="auto">
                  <v-btn
                    color="primary"
                    small
                    :disabled="!canGetInvoices"
                    @click.prevent="getInvoices"
                  >
                    Show invoices
                  </v-btn>
                </v-col>
              </v-row>
              <v-row>
                <h5 class="mx-4">
                  Invoice Total: {{this.invoiceTotal}}
                </h5>
                <h5>
                  Paid Total: {{this.invoicePaidTotal}}
                </h5>
                <v-spacer></v-spacer>
                <v-btn color="success"
                  class="mr-3 mb-0"
                  @click.prevent="addNewInvoice"
                  small
                >
                  Create
                </v-btn>
              </v-row>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <v-data-table
                id="table"
                dense
                class="data-table"
                fixed-header
                mobile-breakpoint="0"
                :headers="headers"
                :items="invoices"
                :height="tableHeight"
                :items-per-page="100"
                :search="search"
                :item-class="itemRowBackground"
                :custom-group="customGroupBy"
                @update:options="currentSortBy"
                @click:row="onRowClick"
                :footer-props="{
                  'items-per-page-options': [100, 200, -1]
                }"
                :group-by="groupBy"
              >
                <!-- Group header -->
                <template v-slot:[`group.header`]="{ items, isOpen, toggle }">
                  <td colspan="2" class="primary white--text text-no-wrap px-2">
                    <div class="d-flex align-center">
                      <v-btn icon small @click="toggle">
                        <v-icon color="white">
                          {{ isOpen ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
                        </v-icon>
                      </v-btn>
                      <span class="subtitle-2 ml-2">{{ groupTitle(items[0]) }}</span>
                    </div>
                  </td>
                  <td
                    class="primary white--text px-2"
                    v-for="(headerItem, headerItemKey) in filteredHeaders.length - 6" :key="headerItemKey">
                  </td>
                  <td class="primary white--text text-no-wrap px-2">
                    <div class="d-flex align-center">
                      <span>Total: {{ totalInvoicesOfGroup(items) }}</span>
                    </div>
                  </td>
                  <td class="primary white--text text-no-wrap px-2">
                    <div class="d-flex align-center">
                      <span>Total: {{ totalPaidInvoicesOfGroup(items) }}</span>
                    </div>
                  </td>
                  <td
                    class="primary white--text px-2"
                  ></td>
                  <td
                    class="primary white--text px-2"
                  ></td>
                </template>
                <!-- /Group header -->
                <template
                  v-slot:[`item.Invoice_Total`]="{ item }"
                >
                  {{ item.Invoice_Total ? (+item.Invoice_Total).toFixed(2) : item.Invoice_Total }}
                </template>
                <template
                  v-slot:[`item.Payment_Total`]="{ item }"
                >
                  {{ item.Payment_Total ? (+item.Payment_Total).toFixed(2) : item.Payment_Total }}
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <InvoiceEditor
      v-if="showEditorDialog"
      v-model="showEditorDialog"
      :invoice="chosenInvoice"
      :invoicePayments="invoicePayments"
      @onInvoicePaymentChange="invoicePaymentChange"
      @added="onInvoiceAdded"
      @updated="onInvoiceUpdated"
      @paymentsUpdated="paymentsUpdated"
      @invoiceDeleted="paymentsUpdated"
    >
    </InvoiceEditor>
  </div>
</template>
<script>

import { generalReportsInvoices } from '../../mixins/GeneralReportsInvoices.js'
import { getApiErrorMessage } from '@/utils/apiError'

export default {
  mixins: [generalReportsInvoices],
  name: 'Invoices',
  components: {
    InvoiceEditor: () => import('../../components/invoices/InvoiceEditor.vue'),
    RangeDatePickerMenu: () => import('@/components/global/RangeDatePickerMenu.vue')
  },
  data () {
    return {
      chosenInvoice: null,
      invoicePayments: [],
      showEditorDialog: false,
      headers: [
        {
          text: 'Invoice Status',
          value: 'Invoice_Status',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap'
        },
        {
          text: 'Account Manager',
          value: 'Account_Manager',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap'
        },
        {
          text: 'Invoice Number',
          value: 'Invoice_Number',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap'
        },
        {
          text: 'Period From',
          value: 'Period_From',
          divider: true,
          width: '100px',
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap'
        },
        {
          text: 'Period To',
          value: 'Period_To',
          divider: true,
          width: '100px',
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap'
        },
        {
          text: 'Client Name',
          value: 'Client_Name',
          divider: true,
          width: '150px',
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap'
        },
        {
          text: 'Project Name',
          value: 'Project_Name',
          divider: true,
          width: '300px',
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap'
        },
        {
          text: 'Department',
          value: 'Department',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap'
        },
        {
          text: 'Invoice Date',
          value: 'Invoice_Date',
          divider: true,
          width: '100px',
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap'
        },
        {
          text: 'Days To Pay',
          value: 'Payment_Period',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap'
        },
        {
          text: 'Due Date',
          value: 'Due_Date',
          divider: true,
          width: '100px',
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap'
        },
        {
          text: 'Invoice Total',
          value: 'Invoice_Total',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap'
        },
        {
          text: 'Paid',
          value: 'Payment_Total',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap'
        },
        {
          text: 'Last Payment Date',
          value: 'Last_Payment_Date',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap'
        },
        {
          text: 'Notes',
          value: 'Notes',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap'
        }

      ],
      groupByItems: [
        {
          title: 'Invoice Number',
          val: 'Invoice_Number'
        },
        {
          title: 'Invoice Status',
          val: 'Invoice_Status'
        },
        {
          title: 'Account Manager',
          val: 'Account_Manager'
        },
        {
          title: 'Client Name',
          val: 'Client_Name'
        },
        {
          title: 'Department',
          val: 'Department'
        },
        {
          title: 'Invoice Date',
          val: 'Invoice_Date'
        },
        {
          title: 'Last Payment Date',
          val: 'Last_Payment_Date'
        },
        {
          title: 'Project Name',
          val: 'Project_Name'
        }
      ]
    }
  },
  computed: {
    tableHeight () {
      const windowW = window.innerWidth
      return windowW < 768 ? '' : 'calc(100vh - 340px)'
    },
    canGetInvoices () {
      return this.filter.DateRange.length === 2
    },
    invoices () {
      const invoices = this.$store.getters.getInvoices
      for (const invoice of invoices) {
        let paidStatus, timeStatus
        // Paid status
        const diffInMoney = invoice.Invoice_Total - (invoice.Payment_Total ? invoice.Payment_Total : 0)
        if (diffInMoney > 0) {
          if (diffInMoney === invoice.Invoice_Total) paidStatus = 'Not Paid'
          else paidStatus = 'Partly Paid'
        } else if (diffInMoney === 0) {
          paidStatus = 'Paid'
        } else {
          paidStatus = 'OverPaid'
        }
        // Time status
        const dateNow = new Date()
        const diffLpdDd = this.differenceBetween2Dates(invoice.Last_Payment_Date, invoice.Due_Date)
        const diffDdNow = this.differenceBetween2Dates(invoice.Due_Date, dateNow)
        if (diffLpdDd >= 0) {
          if ((paidStatus === 'Paid') || (paidStatus === 'OverPaid')) {
            timeStatus = 'In Time'
          } else {
            if (diffDdNow < -5) {
              timeStatus = 'Have Time'
            } else if (diffDdNow < 0) {
              timeStatus = 'Pre-DueDate Warning'
            } else {
              timeStatus = 'DueDate Missed'
            }
          }
        } else {
          if ((paidStatus === 'Paid') || (paidStatus === 'OverPaid')) {
            timeStatus = 'Too Late'
          } else {
            timeStatus = 'DueDate Missed'
          }
        }
        invoice.Invoice_Status = paidStatus + ' — ' + timeStatus
      }
      return this.$store.getters.getInvoices
    },
    invoiceTotal () {
      const key = 'Invoice_Total'
      return this.invoices.reduce((prevVal, item) => {
        return +prevVal.toFixed(2) + +item[key].toFixed(2)
      }, 0).toFixed(2)
    },
    invoicePaidTotal () {
      const key = 'Payment_Total'
      return this.invoices.reduce((prevVal, item) => {
        return +prevVal + +item[key]
      }, 0).toFixed(2)
    }
  },
  methods: {
    customGroupBy (items, groupBy, groupDesc) {
      const groups = []
      items.forEach(item => {
        let cId = ''
        for (let i = 0; i < groupBy.length; i++) {
          cId += item[groupBy[i]]
        }
        const group = groups.find(g => g.name === cId)
        if (group) {
          group.items.push(item)
        } else {
          groups.push({
            name: cId,
            items: [item]
          })
        }
      })
      return groups
    },
    paymentsUpdated () {
      if (this.canGetInvoices) {
        this.getInvoices()
      }
    },
    onInvoiceAdded () {
      this.showEditorDialog = false
      this.$store.dispatch('setSuccess', { successMsg: 'Successfully added' })
      if (this.canGetInvoices) {
        this.getInvoices()
      }
    },
    onInvoiceUpdated (e) {
      this.showEditorDialog = false
      this.$store.dispatch('setSuccess', { successMsg: 'Successfully updated' })
      if (this.canGetInvoices) {
        this.getInvoices()
      }
    },
    getInvoices () {
      this.$store.dispatch('showOverlay', { show: true })
      this.axios.get('/api/invoices', {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        },
        params: {
          Date_From: this.filter.DateRange[0],
          Date_To: this.filter.DateRange[1],
          Client_IDs: this.selectAllClients ? null : this.filter.Client_ID,
          Project_IDs: this.selectAllProjects ? null : this.filter.Project_ID,
          Department_IDs: this.selectAllDepartments ? null : this.filter.Dep_ID,
          sortBy: this.sortBy,
          sortDesc: this.sortDesc
        }
      }).then(res => {
        this.$store.dispatch('setInvoices', { invoices: res.data[0] })
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    addNewInvoice () {
      this.chosenInvoice = null
      this.invoicePayments = []
      this.showEditorDialog = true
    },
    onRowClick (e) {
      this.chosenInvoice = e
      this.getInvoicePayments(e)
      this.showEditorDialog = true
    },
    getInvoicePayments (item) {
      this.axios.get(`/api/invoice/payments/${item.Invoice_ID}`, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then((res) => {
        this.invoicePayments = res.data
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    differenceBetween2Dates (date1, date2) {
      const diffInTime = new Date(date2).getTime() - new Date(date1).getTime()
      const result = diffInTime / (1000 * 3600 * 24)
      return result
    },
    itemRowBackground (item) {
      const parts = item.Invoice_Status.split(' — ')
      let paidStyle, timeStyle
      switch (parts[0]) {
        case 'Not Paid':
        case 'Partly Paid': paidStyle = 'not_paid'; break
        case 'Paid':
        case 'OverPaid': paidStyle = 'paid'; break
        default: paidStyle = ''
      }
      switch (parts[1]) {
        case 'Have Time': timeStyle = 'light_grey'; break
        case 'Pre-DueDate Warning': timeStyle = 'light_orange'; break
        case 'DueDate Missed': timeStyle = 'light_red'; break// 'dueDate_missed'; break
        case 'In Time': timeStyle = 'light_green'; break
        case 'Too Late': timeStyle = 'light_green'; break
        default: timeStyle = ''
      }
      return paidStyle + ' ' + timeStyle
    },
    clearDepartmentList () {
      this.selectAllDepartments = false
      this.searchDepartment = ''
    },
    invoicePaymentChange (e) {
      this.invoicePayments = e
    },
    totalInvoicesOfGroup (items) {
      const key = 'Invoice_Total'
      return items.reduce((prevVal, item) => {
        return +prevVal + +item[key]
      }, 0).toFixed(2)
    },
    totalPaidInvoicesOfGroup (items) {
      const key = 'Payment_Total'
      return items.reduce((prevVal, item) => {
        return +prevVal + +item[key]
      }, 0).toFixed(2)
    }
  }
}
</script>
<style lang="scss">
  #table tbody {
     tr:hover {
        font-weight: bold;
        // background-color: var(--v-hover-base, rgba(0, 0, 0, 0.04)) !important;
     }
  }

  .not_paid {
    color: var(--v-text-base, #000000);
  }
  .paid {
    color: var(--v-text-base, #000000);
  }
  .light_grey {
    background-color: var(--v-grey-light, #DCDCDC) !important;
  }
  .light_orange {
    background-color: var(--v-orange-light, #FFD580) !important;
  }
  .light_red {
    background-color: var(--v-red-light, #FFCCCB) !important;
  }
  .light_green {
    background-color: var(--v-green-light, #90EE90) !important;
  }

  .theme--dark {
    #table tbody {
      tr:hover {
        background-color: var(--v-hover-dark, rgba(255, 255, 255, 0.08)) !important;
      }
    }

    .not_paid {
      color: var(--v-text-dark, #ffffff);
    }
    .paid {
      color: var(--v-text-dark, #ffffff);
    }
    .light_grey {
      background-color: var(--v-grey-dark, #2A2A2A) !important;
      color: #ffffff !important;
    }
    .light_orange {
      background-color: var(--v-orange-dark, #805300) !important;
      color: #ffffff !important;
    }
    .light_red {
      background-color: var(--v-red-dark, #662222) !important;
      color: #ffffff !important;
    }
    .light_green {
      background-color: var(--v-green-dark, #1A471A) !important;
      color: #ffffff !important;
    }
  }
</style>
